import constant from './constants';

const initialState = {
    loading: false,
    insurances: null,
    error: null
};

export const insuranceReducer = (state = initialState , action)=> {
    switch(action.type){
        case constant.INSURANCE_DETAIL_BEGIN: return {...state , loading : true, error: null};
        case constant.INSURANCE_DETAIL_SUCCESS: return {...state , loading : false , insurances: action.payload};
        case constant.INSURANCE_DETAIL_ERROR: return {...state, loading : false , error: action.payload};
        case constant.INSURANCE_DETAIL_CLEANUP: return initialState;
        default: return state;
    }
};